import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  GxButton,
  GxDropdown,
  GxIcon,
  GxInput,
  GxMenu,
  GxMenuDivider,
} from '@garpix/garpix-web-components-react';
import { useStoreon } from 'storeon/react';
import classnames from 'classnames';
import DatePicker from 'react-multi-date-picker';
import Select, { SingleValue } from 'react-select';
import { IFiltersCertificate } from '../../interfaces';
import { months, weekDays } from '../../../../const/calendar';
import styles from './styles/index.module.scss';
import { SearchIcon, SettingsIcon } from '../../../../assets';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/CalendarIcon.svg';
import { customStatusSelect } from '../../../Applications/consts';
import {
  defaultFiltersCertificate,
  statusCertificateOptions,
  typeOrderOptions,
  TYPES_CERTIFICATE,
  TYPES_SIDE_CERTIFICATE,
} from '../../const';
import Burger from '../../../../components/Burger';

const FiltersOverlay = ({ children }:{children: React.ReactNode}) => {
  const { dispatch, certificatesParamsApi } = useStoreon(
    'certificatesParamsApi',
    'statusLoadCertificates'
  );
  const [filters, setFilters] = useState<IFiltersCertificate>(
    defaultFiltersCertificate
  );
  const changeFilters = (params: any) => {
    dispatch('certificatesApi/change', { ...filters, ...params, page: null });
    dispatch('certificates/get');
    setFilters({ ...filters, ...params, page: null });
  };

  function CustomRangeInput({ openCalendar, value }: any) {
    let valueNew = `${dayjs(value).format('DD.MM.YYYY')}`;
    if (value === '') valueNew = '- -- -';

    return (
      <div className={styles['calendar']}>
        <input
          readOnly
          value={valueNew}
          className={styles['calendar--input']}
          onFocus={openCalendar}
        />
        <div role='button' tabIndex={0} onClick={openCalendar}>
          <CalendarIcon className={styles['button--icon_calendar']} />
        </div>
      </div>
    );
  }

  const handleClickResetFilters = () => {
    setFilters(defaultFiltersCertificate);
    dispatch('certificatesApi/clear');
    dispatch('certificates/get');
  };
  useEffect(() => {
    return () => {
      dispatch('certificatesApi/change', { search: null, party: null });
    };
  }, []);

  function Filters() {
    return (
      <>
        <label htmlFor='search' className={styles['search--group']}>
          <div
            className={styles['search--icon']}
            onClick={() => {
              dispatch('certificates/get');
            }}
            role='button'
            tabIndex={0}
          >
            <GxIcon src={SearchIcon} />
          </div>
          <GxInput
            placeholder='Поиск'
            name='search'
            id='search'
            value={certificatesParamsApi.search}
            className={styles['search--input']}
            onGx-keyPress={(e: any) => {
              if (e.key === 'Enter') {
                console.log('enter press here! ');
              }
            }}
            onGx-change={(e: any) => {
              changeFilters({ search: e.target.value });
            }}
            clearable={
              certificatesParamsApi.search &&
              certificatesParamsApi.search.length > 0
            }
            onGx-clear={() => {
              dispatch('certificatesApi/change', { search: null });
              dispatch('certificates/get');
            }}
          />
        </label>
        <label
          htmlFor='select-task'
          className={classnames(
            styles['select--group'],
            styles['select--group__status']
          )}
        >
          <span className={styles['select--title']}>Статус:</span>
          <Select
            options={statusCertificateOptions}
            value={
              filters.status !== null
                ? statusCertificateOptions[filters.status]
                : statusCertificateOptions[TYPES_CERTIFICATE.ALL]
            }
            styles={customStatusSelect}
            onChange={(e: SingleValue<{ value: number; label: string }>) => {
              changeFilters({
                status: e?.value === TYPES_CERTIFICATE.ALL ? null : e?.value,
              });
            }}
          />
        </label>
        <label htmlFor='select-task' className={styles['select--group']}>
          <span className={styles['select--title']}>Тип:</span>
          <Select
            options={typeOrderOptions}
            value={
              filters.side !== null
                ? typeOrderOptions[filters.side]
                : typeOrderOptions[TYPES_SIDE_CERTIFICATE.ALL]
            }
            styles={customStatusSelect}
            onChange={(e: SingleValue<{ value: number; label: string }>) => {
              changeFilters({
                side: e?.value === TYPES_SIDE_CERTIFICATE.ALL ? null : e?.value,
              });
            }}
          />
        </label>
        <label htmlFor='date' className={styles['filters-date--item']}>
          <span className={styles['filters-date--label']}>Дата продажи:</span>
          <DatePicker
            weekDays={weekDays}
            months={months}
            value={dayjs(filters.date_sale).toDate()}
            name='date'
            weekStartDayIndex={1}
            onChange={(e: any) => {
              changeFilters({ date_sale: dayjs(e).format('YYYY-MM-DD') });
            }}
            render={<CustomRangeInput />}
          />
          {filters.date_sale && (
            <span
              className={styles['filters-date--info__item_close']}
              onClick={() => changeFilters({ date_sale: null })}
              role='button'
              tabIndex={0}
            />
          )}
        </label>
        <label htmlFor='search-input' className={styles['search--group']}>
          <div
            className={styles['search--icon']}
            onClick={() => {
              dispatch('certificates/get');
            }}
            role='button'
            tabIndex={0}
          >
            <GxIcon src={SearchIcon} />
          </div>
          <GxInput
            placeholder='Партия'
            name='search-input'
            value={certificatesParamsApi.party}
            className={styles['search--input']}
            clearable={
              certificatesParamsApi.party &&
              certificatesParamsApi.party.length > 0
            }
            onGx-change={(e: any) => {
              dispatch('certificatesApi/change', {
                party: e.target.value === '' ? null : e.target.value,
              });
            }}
            onGx-clear={() => {
              dispatch('certificatesApi/change', { party: null });
              dispatch('certificates/get');
            }}
          />
        </label>
      </>
    );
  }

  return (
    <>
      <div className={styles['header']}>
        <Burger />
        <span className={styles['header--title']}>Сертификаты</span>
      </div>
      <div className={styles['panel']}>
        <div className={styles['panel--wrapper']}>
          <div className={styles['panel__left-group']}>
            <GxDropdown className={styles['dropdown_mobile']} distance={12}>
              <GxIcon
                src={SettingsIcon}
                className={styles['dropdown_mobile--icon']}
                slot='trigger'
              />
              <GxMenu className={styles['dropdown_mobile--menu']}>
                <span className={styles['dropdown_mobile--subtitle']}>
                  Поиск и фильтр сертификатов
                </span>
                <GxMenuDivider />
                <Filters />
              </GxMenu>
            </GxDropdown>
            <div className={styles['panel__left-group--container']}>
              <Filters />
            </div>
          </div>
          <div className={styles['panel__right-group']}>
            <GxButton
              className={classnames(
                styles['button'],
                styles['button--create_task']
              )}
              onClick={handleClickResetFilters}
            >
              <span>Сбросить все фильтры</span>
            </GxButton>
          </div>
        </div>
      </div>
      {children}
    </>
  );
};

export default FiltersOverlay;
